module.exports = __webpack_public_path__ + "img/qiayang-2.beb599d2.jpg";